<div class="logs-container">
  <div class="logs-header">
    <h1>Registro de Logs</h1>
    <p class="subtitle">Visualiza y gestiona los diferentes tipos de logs del sistema</p>
  </div>

  <div class="logs-navigation">
    <button 
      *ngFor="let logType of logTypes"
      class="log-tab"
      [class.active]="selectedLog === logType.id"
      (click)="selectLog(logType.id)">
      <span>{{ logType.name | translate }}</span>
    </button>
  </div>

  <div class="logs-content">
    <div [ngSwitch]="selectedLog">
      <app-sale-logs *ngSwitchCase="'sales'"></app-sale-logs>
      <app-beneficiaries-log *ngSwitchCase="'beneficiaries'"></app-beneficiaries-log>
      <div *ngSwitchDefault class="no-logs">
        <p>Selecciona un tipo de log para ver su contenido</p>
      </div>
    </div>
  </div>
</div>